import { connect } from 'react-redux';
import { demoMetricDictionary, demoMetricsKeys } from './Demo/data';
import { getSSPData } from '../../selectors';
import dictionariesTypesEnum from '../../../../common/constants/dictionaries';
import { getChargerMetrics, getDefaultDotsLimitHistorical, getTelemetryPeriodicityHistorical } from './store/selectors';
import { loadDictionary } from '../../../AdminTools/components/TelemetryDictionary/actions';
import { makeLoadMetrics, makeSnapshotFromMetrics } from './Demo';
import {
  loadChargerMetrics,
  loadRealTimeMetrics,
  setChargerMetrics,
  setChargerMetricsByAggregation,
  setChargerSnapshot,
} from './store/actions';

import View from './TelemetryComponent';
import { AGGREGATIONS_FOR_GRAPH } from './const';

const mapStateToProps = (state, { demo }) => ({
  metricDictionary: demo
    ? demoMetricDictionary
    : getSSPData(state, dictionariesTypesEnum.telemetryMetrics, [])
      .filter((metric) => metric && metric.status === 'ACTIVE'),
  chargerMetrics: getChargerMetrics(state),
  defaultDotsLimit: getDefaultDotsLimitHistorical(state),
  telemetryPeriodicity: getTelemetryPeriodicityHistorical(state),
});

const mapDispatchToProps = (dispatch, { chargerId, demo }) => ({
  loadMetricsDictionary: () => {
    dispatch(loadDictionary(dictionariesTypesEnum.telemetryMetrics, {
      filter_by: {},
      sorting: { id: 'code', desc: 'DESC' },
      page_size: 1000,
      page_token: 0,
    }));
  },
  loadRealTimeMetrics: (filters, isHistory = false, ok, fail) => {
    if (demo) {
      const metrics = makeLoadMetrics({
        ...filters,
        metrics: Object.keys(demoMetricsKeys),
      }, { type: 'realtime' });

      const snapshot = makeSnapshotFromMetrics(metrics);

      if (snapshot) {
        dispatch(setChargerSnapshot(snapshot));
      }

      isHistory && dispatch(setChargerMetrics(metrics));
    } else {
      dispatch(loadRealTimeMetrics(chargerId, filters, isHistory, { ok, fail }));
    }
  },
  loadHistoryMetrics: (filters, ok, fail) => {
    if (demo) {
      AGGREGATIONS_FOR_GRAPH.forEach((aggregation) => {
        filters.aggregation = aggregation;
        const metrics = makeLoadMetrics(filters, { type: 'historical' });

        dispatch(setChargerMetricsByAggregation(aggregation, metrics));
      });
    } else {
      dispatch(loadChargerMetrics(chargerId, filters, { ok, fail }));
    }
  },
  clearMetrics: () => dispatch(setChargerMetrics([])),
});

const Telemetry = connect(mapStateToProps, mapDispatchToProps)(View);

export default Telemetry;
